import { render } from "./AwaitBankAccountPanel.vue?vue&type=template&id=64e0d26a&scoped=true"
import script from "./AwaitBankAccountPanel.vue?vue&type=script&lang=js"
export * from "./AwaitBankAccountPanel.vue?vue&type=script&lang=js"

import "./AwaitBankAccountPanel.vue?vue&type=style&index=0&id=64e0d26a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e0d26a"]])

export default __exports__